export default __webpack_public_path__ + "static/media/host_managerLogin.ea009e07.svg";